// src/components/site-editor/ServiceLimitModal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

/**
 * ServiceLimitModal - Shown when practitioner tries to add a service beyond their tier limit
 *
 * Free tier: 1 service max
 * Pro tier: 3 services max
 * Elite tier: Unlimited (this modal never shown)
 */
const ServiceLimitModal = ({ isOpen, onClose, tier, currentCount }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  // Tier-specific copy
  const copy = {
    free: {
      title: "Want to add more services?",
      message: "The Essentials plan includes 1 service. Upgrade to offer more to your clients.",
      plan: "Professional",
      price: "$49/month"
    },
    pro: {
      title: "Want to add more services?",
      message: "The Professional plan includes up to 3 services. Upgrade to Premier for unlimited services.",
      plan: "Premier",
      price: "$99/month"
    }
  };

  const content = copy[tier] || copy.pro;

  const handleUpgrade = () => {
    navigate('/pricing');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div
        className="bg-white rounded-xl shadow-xl"
        style={{ maxWidth: '400px', padding: '24px' }}
      >
        {/* Icon - smaller */}
        <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mb-3">
          <Sparkles className="w-4 h-4 text-white" />
        </div>

        {/* Title */}
        <h3
          className="text-gray-900 mb-2"
          style={{ fontSize: '16px', fontWeight: 600 }}
        >
          {content.title}
        </h3>

        {/* Message */}
        <p
          className="mb-5"
          style={{ fontSize: '14px', color: '#6B7280' }}
        >
          {content.message}
        </p>

        {/* Action Buttons - right-aligned row */}
        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
            style={{ background: 'none', border: 'none', padding: '8px 12px' }}
          >
            Got It
          </button>
          <button
            onClick={handleUpgrade}
            className="px-5 py-2 text-sm font-semibold text-white bg-purple-600 hover:bg-purple-700 rounded-lg transition-all shadow-sm hover:shadow-md"
          >
            View Plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceLimitModal;
